module.exports = __webpack_public_path__ + "static/assets/901313e4f9e46307d15e1f580d90d138.svg";